import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { StatsActionCreators } from 'app/reducers/StatsRedux'
import store from 'services/store'
import {
  LineChart,
  AreaChart,
  PieChart,
  BarChart,
  Pie,
  Cell,
  Area,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts'

import { colors } from 'theme'
import Chart from './Chart'
import { container } from '../styles'

const dataPortals = [
  { portal: 'Vivanuncios', contacts: 400 },
  { portal: 'Inmuebles24', contacts: 620 },
  { portal: 'SegundaMano', contacts: 330 },
  { portal: 'Propiedades', contacts: 353 }
]

const dataPT = [
  {
    month: 'Enero',
    target: 4000,
    sales: 2400,
    forSale: 5,
    rents: 240,
    forRent: 3,
    cancelled: 3,
    done: 10,
    failure: 3
  },
  {
    month: 'Febrero',
    target: 3000,
    sales: 1398,
    forSale: 4,
    rents: 138,
    forRent: 1,
    cancelled: 4,
    done: 10,
    failure: 1
  },
  {
    month: 'Marzo',
    target: 2000,
    sales: 9800,
    forSale: 6,
    rents: 980,
    forRent: 0,
    cancelled: 3,
    done: 15,
    failure: 4
  },
  {
    month: 'Abril',
    target: 2780,
    sales: 3908,
    forSale: 2,
    rents: 398,
    forRent: 3,
    cancelled: 0,
    done: 5,
    failure: 1
  }
]

const seriesPT = [
  {
    text: 'Performance',
    color: colors.primary
  },
  {
    text: 'Target',
    color: colors.secondary
  }
]

const seriesSales = [
  {
    text: 'Ventas',
    color: colors.primary
  },
  {
    text: 'Rentas',
    color: colors.secondary
  }
]

const seriesForSales = [
  {
    text: 'Para vender',
    color: colors.primary
  },
  {
    text: 'Para rentar',
    color: colors.secondary
  }
]

const seriesAppointments = [
  {
    text: 'Canceladas',
    color: colors.danger
  },
  {
    text: 'Realizadas',
    color: colors.primary
  },
  {
    text: 'No Realizadas',
    color: colors.secondary
  }
]

const seriesPortals = [
  { text: 'Vivanuncios', color: colors.primary },
  { text: 'Inmuebles24', color: colors.secondary },
  { text: 'SegundaMano', color: colors.danger },
  { text: 'Propiedades', color: colors.border }
]

class Charts extends PureComponent {
  UNSAFE_componentWillMount() {
    this.props.actions.getStats()
  }

  render() {
    const { stats } = this.props

    return (
      <section className="container">
        <header>Mis estadísticas</header>

        <Chart title="Mis propiedades" series={seriesForSales}>
          <ResponsiveContainer width="100%" height="auto" aspect={4.0 / 3.0}>
            <BarChart
              data={stats.propertiesAmount}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <Bar dataKey="forSale" fill={colors.primary} />
              <Bar dataKey="forRent" fill={colors.secondary} />
            </BarChart>
          </ResponsiveContainer>
        </Chart>

        <Chart title="Valor de mi cartera (MXN)" series={seriesSales}>
          <ResponsiveContainer width="100%" height="auto" aspect={4.0 / 3.0}>
            <BarChart
              data={stats.portfolioValueMxn}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <Bar dataKey="sales" fill={colors.primary} />
              <Bar dataKey="rents" fill={colors.secondary} />
            </BarChart>
          </ResponsiveContainer>
        </Chart>

        <Chart title="Valor de mi cartera (USD)" series={seriesSales}>
          <ResponsiveContainer width="100%" height="auto" aspect={4.0 / 3.0}>
            <BarChart
              data={stats.portfolioValueUsd}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip />
              <Bar dataKey="sales" fill={colors.primary} />
              <Bar dataKey="rents" fill={colors.secondary} />
            </BarChart>
          </ResponsiveContainer>
        </Chart>
{/*
        <Chart title="Contactos por portal" series={seriesPortals}>
          <ResponsiveContainer width="100%" height="auto" aspect={4.0 / 3.0}>
            <PieChart>
              <Tooltip />
              <Pie
                data={dataPortals}
                fill={colors.danger}
                dataKey="contacts"
                label
              >
                {seriesPortals.map((s, i) => <Cell key={i} fill={s.color} />)}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Chart>

        <Chart title="Evolución de citas" series={seriesAppointments}>
          <ResponsiveContainer width="100%" height="auto" aspect={4.0 / 3.0}>
            <AreaChart
              data={dataPT}
              margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Tooltip />
              <Area type="monotone" dataKey="done" fill={colors.primary} />
              <Area type="monotone" dataKey="failure" fill={colors.secondary} />
              <Area type="monotone" dataKey="cancelled" fill={colors.danger} />
            </AreaChart>
          </ResponsiveContainer>
        </Chart>

        <Chart title="Performance vs Target" series={seriesPT}>
          <ResponsiveContainer width="100%" height="auto" aspect={4.0 / 3.0}>
            <LineChart
              data={dataPT}
              margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Tooltip />
              <Line type="monotone" dataKey="sales" stroke={colors.primary} />
              <Line
                type="monotone"
                dataKey="target"
                stroke={colors.secondary}
              />
            </LineChart>
          </ResponsiveContainer>
        </Chart>
        */}
        {/* <Chart title="Evolucion Ventas | Rentas" series={seriesSales}>
          <ResponsiveContainer width="100%" height="auto" aspect={4.0 / 3.0}>
            <LineChart
              data={stats.profitEvolution}
              margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Tooltip />
              <Line type="monotone" dataKey="sales" stroke={colors.primary} />
              <Line type="monotone" dataKey="rents" stroke={colors.secondary} />
            </LineChart>
          </ResponsiveContainer>
        </Chart> */}
        <style jsx>{container}</style>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  stats: state.stats
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getStats: StatsActionCreators.getStatsRequest
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  Charts
)
